import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/btc-tools/configs')({
  beforeLoad: authorizedRouteLoader('btcTools.configs'),
  component: Outlet,
});
